import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useUserStore from '../../stores/userStore';

const ProtectedRoute = ({ children }) => {
  const { loginFlag, token } = useUserStore();
  const location = useLocation();

  // If user is not logged in, redirect to login page
  if (!loginFlag || !token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
